var map = {
	"./033-bm.webp": 1286,
	"./033-cn.webp": 1287,
	"./033.webp": 1288,
	"./13-bm.webp": 1289,
	"./13-cn.webp": 1290,
	"./13.webp": 1291,
	"./3-bm.webp": 1292,
	"./3-cn.webp": 1293,
	"./3.webp": 1294,
	"./angpao-bm.webp": 1295,
	"./angpao-cn.webp": 1296,
	"./angpao.webp": 1297
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1285;